import { Button } from '@resurs/midas-react'
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import PageWrapper from '../../../../internal/PageWrapper'
import { getText } from '../../../../internal/TextLabels'
import styles from './styles.module.scss'
import {
  pageHalt,
  getPayment,
  getSigningStatus,
} from '../../../../store/actions/pay-apply-actions'
import ApplicationSummaryBox from '../shared/ApplicationSummaryBox'

class PaymentAdjustAmountPage extends Component {
  validateAmountIfDebit() {
    const { paymentResult } = this.props.data.payment
    const { selectedAmount: debitAmount, selectedPaymentMethod } =
      this.props.data.current

    const minLimit = Math.max(1, selectedPaymentMethod.minPurchaseLimit)
    const maxLimit = paymentResult.application.approvedAmount

    if (debitAmount < minLimit) {
      return `${getText('payApply.paymentMethod.creditToSmall')} ${getText(
        'default.currency',
        minLimit,
      )}`
    }
    if (debitAmount > maxLimit) {
      return `${getText(
        'payApply.paymentMethod.newCreditNeededText',
      )} ${getText('default.currency', maxLimit)}`
    }
    return ''
  }

  render() {
    const { paymentResult } = this.props.data.payment
    const { debitReference } = this.props.data.current

    const debitAmountError = this.validateAmountIfDebit()
    return (
      <div style={{ marginBottom: '5rem' }}>
        <PageWrapper noPadding type="warning">
          <div
            style={{
              display: 'relative',
              padding: '2rem',
            }}
          >
            <div style={{ display: 'flex' }}>
              <h5 style={{ margin: '1.2rem 0' }}>
                {getText('payApply.lowerPurchaseAmountRequired.title')}
              </h5>
            </div>
          </div>
        </PageWrapper>

        <PageWrapper noPadding>
          <div style={{ padding: '2rem' }} className={styles.signPage}>
            <ApplicationSummaryBox
              result={paymentResult}
              debitReference={debitReference}
              onPageLoading={this.props.data.wizard.onPageLoading}
              updateApplication={() =>
                this.props.updatePayment(paymentResult.id, true)
              }
              errorMessage={debitAmountError}
              infoText="payApply.lowerPurchaseAmountRequired.infoText"
            />
            <div
              style={{
                marginTop: '1rem',
                textAlign: 'right',
              }}
            >
              <Button
                id="digital-sign-btn"
                type="primary"
                loading={this.props.data.wizard.newPageLoading}
                disabled={!!debitAmountError}
                autoFocus
                onClick={e => {
                  e.preventDefault()
                  this.props.onNext()
                }}
              >
                {getText('default.next')}
              </Button>
            </div>
          </div>
        </PageWrapper>
      </div>
    )
  }
}

PaymentAdjustAmountPage.propTypes = {
  data: PropTypes.object.isRequired,
  onNext: PropTypes.func.isRequired,
  updatePayment: PropTypes.func.isRequired,
}

const mapStateToProps = state => ({
  authorities: state.auth.authorities,
})

const mapDispatchToProps = dispatch => ({
  updatePayment: (id, onPageLoad) => dispatch(getPayment(id, onPageLoad)),
  onPageHalt: () => dispatch(pageHalt()),
  updateSigningStatus: () => dispatch(getSigningStatus),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PaymentAdjustAmountPage)
